import { Branch } from "../gen/clients/llts";
import { isUkBranchId } from "./apiBaseUrl";
import { prependBranchSegment, stripBranchSegment } from "./branchPathUtils";

export enum Region {
  US = "US",
  UK = "UK"
}

export const UK_REGION_BRANCH_ID = "en-gb";

export const getRegionFromBranchId = (branchId: string | null | undefined): Region =>
  isUkBranchId(branchId || undefined) ? Region.UK : Region.US;

export const getRegionFromUserBranch = (branch: Branch | null | undefined): Region => getRegionFromBranchId(branch?.id);

export const getBranchIdForRegion = (region: Region): string | undefined =>
  region === Region.UK ? UK_REGION_BRANCH_ID : undefined;

export const buildPathnameForRegion = (
  pathname: string,
  currentBranchId: string | undefined,
  targetRegion: Region
): string => {
  const pathWithoutBranch = stripBranchSegment(pathname, currentBranchId);
  const targetBranchId = getBranchIdForRegion(targetRegion);
  return targetBranchId ? prependBranchSegment(pathWithoutBranch, targetBranchId) : pathWithoutBranch;
};
